import { CertificationCard } from "@/components/pages_logged_in/certifications/CertificationCard";
import { CertificationsQuery } from "@/graphql";

export function CertificationsList({
  certifications,
}: {
  certifications: NonNullable<
    CertificationsQuery["currentWorkspace"]
  >["certifications"]["data"];
}) {
  return (
    <div className="flex flex-col gap-4 w-full">
      {certifications.map((certification) => (
        <CertificationCard
          key={certification.id}
          certification={certification}
        />
      ))}
    </div>
  );
}
